var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop } from "vue-property-decorator";
import { SideNav } from "../Components/SideNav.ts";
import Log from "../Directives/Log.ts";
var Wizard = /** @class */ (function (_super) {
    __extends(Wizard, _super);
    function Wizard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submittingCallbacks = [];
        _this.submitClicked = false;
        _this.submitting = false;
        _this.tabIndex = 0;
        _this.tabCount = 0;
        _this.sideNavKey = 1;
        return _this;
    }
    Object.defineProperty(Wizard.prototype, "form", {
        get: function () {
            return this.$refs.form;
        },
        enumerable: true,
        configurable: true
    });
    Wizard.prototype.mounted = function () {
        this.calculateTabCount();
        window.$bus.$on("form.submitting.callback", this.submittingCallback);
    };
    Wizard.prototype.destroyed = function () {
        window.$bus.$off("form.submitting.callback", this.submittingCallback);
    };
    Wizard.prototype.submittingCallback = function (callback) {
        this.submittingCallbacks.push(callback);
    };
    Wizard.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var callbacks, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.$v.$touch();
                        this.submitClicked = true;
                        if (!this.$v.$invalid) return [3 /*break*/, 1];
                        this.focusInvalid();
                        return [3 /*break*/, 5];
                    case 1:
                        window.$bus.$emit("form.submitting");
                        callbacks = this.submittingCallbacks;
                        this.submittingCallbacks = [];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, Promise.all(callbacks)];
                    case 3:
                        _b.sent();
                        this.submitting = true;
                        this.form.submit();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        this.focusInvalid();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Wizard.prototype.calculateTabCount = function () {
        this.tabCount = this.$slots.default.filter(function (p) { return p.componentOptions && p.componentOptions.Ctor.extendOptions.name === "SideNavPage"; }).length;
    };
    Object.defineProperty(Wizard.prototype, "isFirstTab", {
        get: function () {
            return this.tabIndex <= 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Wizard.prototype, "isLastTab", {
        get: function () {
            return this.tabIndex >= (this.tabCount - 1);
        },
        enumerable: true,
        configurable: true
    });
    Wizard.prototype.focusInvalid = function () {
        var _this = this;
        if (!this.form)
            return;
        Vue.nextTick().then(function () {
            var firstInvalid = _this.form.querySelector(".form-control.is-invalid,.input-group .is-invalid");
            if (!firstInvalid)
                return;
            if (!_this.singleTab) {
                var tab = firstInvalid.closest(".tab-pane");
                if (!tab || !tab.parentElement)
                    return;
                _this.tabIndex = Array.from(tab.parentElement.children).indexOf(tab);
            }
            Vue.nextTick().then(function () {
                firstInvalid.scrollIntoView(false);
                firstInvalid.focus();
            });
        });
    };
    Wizard.prototype.refresh = function () {
        var _this = this;
        this.sideNavKey++;
        Vue.nextTick().then(function () {
            _this.calculateTabCount();
        });
    };
    __decorate([
        Prop({ type: String, required: true })
    ], Wizard.prototype, "action", void 0);
    __decorate([
        Prop({ type: String, default: "post" })
    ], Wizard.prototype, "method", void 0);
    __decorate([
        Prop({ type: String, default: "application/x-www-form-urlencoded", validator: function (value) { return value && ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"].indexOf(value.toLowerCase()) !== -1; } })
    ], Wizard.prototype, "enctype", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Wizard.prototype, "pills", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Wizard.prototype, "vertical", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Wizard.prototype, "singleTab", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Wizard.prototype, "formMode", void 0);
    __decorate([
        Prop({ type: String, default: "right", validator: function (value) { return value && ["right", "left"].indexOf(value.toLowerCase()) !== -1; } })
    ], Wizard.prototype, "buttonTrayLocation", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Wizard.prototype, "cancelUrl", void 0);
    __decorate([
        Prop({ type: String, default: "Cancel" })
    ], Wizard.prototype, "cancelText", void 0);
    __decorate([
        Prop({ type: String, default: "Previous" })
    ], Wizard.prototype, "previousText", void 0);
    __decorate([
        Prop({ type: String, default: "Next" })
    ], Wizard.prototype, "nextText", void 0);
    __decorate([
        Prop({ type: String, default: "Finish" })
    ], Wizard.prototype, "finishText", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], Wizard.prototype, "$v", void 0);
    Wizard = __decorate([
        Component({
            name: "Wizard",
            components: {
                SideNav: SideNav
            },
            directives: {
                Log: Log
            }
        })
    ], Wizard);
    return Wizard;
}(Vue));
export default Wizard;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Wizard.vue
// module id = 71
// module chunks = 2 3 4 6 10 12